module.exports = __webpack_public_path__ + "img/nyc.88b8bccb.png";